import { render, staticRenderFns } from "./role-edit.vue?vue&type=template&id=74af6311&scoped=true&"
import script from "./role-edit.vue?vue&type=script&lang=js&"
export * from "./role-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74af6311",
  null
  
)

export default component.exports